<template>
  <div class="relative inline-block text-left">
    <div>
      <span class="shadow-sm">
        <button
          type="button"
          @click="isVisibleSubNav = !isVisibleSubNav"
          :class="[
            'flex justify-center w-full leading-5 font-bold focus:border-primary-light focus:outline-none focus:ring active:text-gray-800 transition ease-in-out duration-150',
            context,
          ]"
          id="options-menu"
          aria-haspopup="true"
          aria-expanded="true"
        >
          <div :class="['relative flex items-center justify-center', size, font]">
            <span
              :class="[
                'space-x-2 items-center justify-center w-full truncate',
                $attrs.loading ? 'hidden' : 'flex',
              ]"
            >
              <slot />
            </span>
            <base-icon
              v-if="$attrs.loading"
              icon="spinner-btn"
              :class="['animate-spin']"
              style="font-size: 150%"
            />
            <svg class="-mr-1 ml-2 h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
              <path
                fill-rule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
        </button>
      </span>
    </div>

    <div
      v-if="isVisibleSubNav && !$attrs.loading"
      class="origin-top-right absolute right-0 mt-1 shadow-lg min-w-full z-100"
    >
      <div
        class="bg-white ring-1 ring-black ring-opacity-5"
        role="menu"
        aria-orientation="vertical"
        aria-labelledby="options-menu"
      >
        <slot name="menu" />
      </div>
    </div>
  </div>
</template>

<script>
import BaseIcon from './_base-icon.vue'
import {btnStyle} from '@/state/helpers/mixins.js'

export default {
  components: {BaseIcon},
  mixins: [btnStyle],
  data() {
    return {
      isVisibleSubNav: false,
    }
  },
  methods: {
    blur() {
      this.isVisibleSubNav = false
    },
  },
  computed: {
    context() {
      return typeof this.$attrs.context !== 'undefined'
        ? `bg-${this.$attrs.context}-light hover:bg-${this.$attrs.context}-dark hover:bg-opacity-50`
        : 'bg-primary text-white hover:bg-primary-light'
    },
  },
  // directives: {
  //   ClickOutside,
  // },
}
</script>
